export const SIDEBAR_MENUS = [
  { label: 'Dashboard', to: '/breach-management/dashboard' },
  { label: 'Daily Trends', to: '/breach-management/daily-trends' },
];
